import { render, staticRenderFns } from "./UpsellSheetProduct.vue?vue&type=template&id=4efca86b&lang=pug"
import script from "./UpsellSheetProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpsellSheetProduct.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports